import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

const specialFeatures = [
  {
    title: '랜드마크 디자인',
    desc: '청주시의 품격을 담은 49층 고층 설계의 특별한 디자인',
    img: 'https://public.readdy.ai/ai/img_res/f2a69019536c41818a73899df8c48e6b.jpg',
  },
  {
    title: '전세대 남향 배치',
    desc: '단지 내 모든 세대 남향, 남서향형 통풍이 배치',
    img: 'https://readdy.ai/api/search-image?query=aerial%20view%20apartment%20complex%20south%20facing%20layout%20floor%20plan%20Korea%20residential%20building%20site%20plan%20bird%20eye%20view%20architecture%20design&width=400&height=300&seq=special02&orientation=portrait',
  },
  {
    title: '차별화된 커뮤니티',
    desc: '입주민의 눈높이 맞는 공동시설 및 프리미엄 커뮤니티 제공으로 새로운 가치 창출',
    img: 'https://readdy.ai/api/search-image?query=premium%20apartment%20community%20facility%20gym%20fitness%20center%20indoor%20pool%20lounge%20modern%20interior%20luxury%20residential%20amenity%20Korea&width=400&height=300&seq=special03&orientation=portrait',
  },
  {
    title: '친환경 단지 설계',
    desc: '녹색 공원부터 산책이 가능한 친환경 단지 조성 에코파크',
    img: 'https://readdy.ai/api/search-image?query=eco%20friendly%20green%20park%20apartment%20complex%20landscape%20garden%20walking%20path%20trees%20nature%20residential%20Korea%20environment%20friendly%20design&width=400&height=300&seq=special04&orientation=portrait',
  },
];

const smartFeatures = [
  {
    title: '스마트홈 월패드',
    desc: '각 세대 공기질부터 원룸 시스템 방범까지 도어 수신부터 모두 가능',
    img: 'https://readdy.ai/api/search-image?query=smart%20home%20wall%20pad%20touch%20screen%20apartment%20control%20panel%20interior%20modern%20home%20automation%20system%20Korea%20residential%20technology%20device&width=400&height=300&seq=smart01&orientation=portrait',
  },
  {
    title: '에너지 관리 시스템',
    desc: '검침부터 세대별 절전모드 에너지 절감으로 진정으로 손쉽게 관리 가능',
    img: 'https://readdy.ai/api/search-image?query=energy%20management%20system%20smart%20light%20bulb%20electricity%20saving%20technology%20modern%20home%20automation%20LED%20lighting%20efficiency%20Korea%20apartment&width=400&height=300&seq=smart02&orientation=portrait',
  },
  {
    title: '스마트폰 키 시스템',
    desc: '스마트폰 공동현관으로 공동현관 출입 및 엘리베이터 자동호출 가능',
    img: 'https://readdy.ai/api/search-image?query=smartphone%20digital%20door%20lock%20smart%20key%20system%20apartment%20entrance%20mobile%20phone%20NFC%20access%20control%20modern%20security%20Korea%20residential&width=400&height=300&seq=smart03&orientation=portrait',
  },
  {
    title: '클린홈 특화 시스템',
    desc: '세대 방향 공기청정의 물론 욕실 제습 건조 드라이어 가능하며 가능한 최첨단 단지',
    img: 'https://readdy.ai/api/search-image?query=clean%20home%20air%20purifier%20bathroom%20dryer%20ventilation%20system%20modern%20apartment%20interior%20white%20minimalist%20Korea%20premium%20residential%20technology&width=400&height=300&seq=smart04&orientation=portrait',
  },
];

const securityFeatures = [
  {
    title: '키즈 통학 스테이션',
    desc: '등하교 시 반기고 마치는 안전한 서비스로 운행 가능한 킴스테이션',
    img: 'https://readdy.ai/api/search-image?query=school%20bus%20kids%20safety%20station%20apartment%20complex%20children%20commute%20service%20Korea%20residential%20safe%20zone%20yellow%20bus%20stop&width=400&height=300&seq=sec01&orientation=portrait',
  },
  {
    title: '시큐리티 도어록',
    desc: '비밀번호, 카드키, 지문 및 안면 인식으로 도어 보안 출입 가능',
    img: 'https://readdy.ai/api/search-image?query=security%20door%20lock%20face%20recognition%20fingerprint%20smart%20digital%20lock%20apartment%20entrance%20modern%20technology%20Korea%20premium%20residential%20access%20control&width=400&height=300&seq=sec02&orientation=portrait',
  },
  {
    title: '지하주차장 비상벨',
    desc: '지하주차장 비상벨을 설치하여 조속히 대처하면서 코너마다 및 통합 가능',
    img: 'https://readdy.ai/api/search-image?query=underground%20parking%20emergency%20bell%20safety%20zone%20Korea%20apartment%20complex%20security%20system%20yellow%20warning%20sign%20safe%20area&width=400&height=300&seq=sec03&orientation=portrait',
  },
  {
    title: '무인 경비 시스템',
    desc: '자율주행 로봇의 24시간 입주민도 안전한 생활 가능',
    img: 'https://readdy.ai/api/search-image?query=autonomous%20security%20robot%20patrol%20apartment%20complex%20unmanned%20guard%20system%20AI%20robot%20outdoor%20surveillance%20Korea%20residential%2024%20hours&width=400&height=300&seq=sec04&orientation=portrait',
  },
];

const parkingFeatures = [
  {
    title: '주차위치 저장 시스템',
    desc: '스마트폰과 연계해 바로 자동 스마트폰으로 내 차량으로 찾기 서비스 제공',
    img: 'https://readdy.ai/api/search-image?query=smart%20parking%20location%20save%20system%20smartphone%20app%20map%20underground%20parking%20Korea%20apartment%20find%20my%20car%20mobile%20navigation%20technology&width=400&height=300&seq=park01&orientation=portrait',
  },
  {
    title: '무인 주차관제 시스템',
    desc: '이미지 프로세싱의 활용한 3대 1 및 동시에 실시간 시 차량에서 바로 가능',
    img: 'https://readdy.ai/api/search-image?query=unmanned%20parking%20control%20system%20automated%20parking%20management%20Korea%20apartment%20complex%20entrance%20gate%20barrier%20license%20plate%20recognition%20technology&width=400&height=300&seq=park02&orientation=portrait',
  },
  {
    title: '초고해상도 CCTV',
    desc: '동시에 실시간 모든 주차장 내 실시간 영상 감시 및 저화질에서 이용 가능',
    img: 'https://readdy.ai/api/search-image?query=high%20resolution%20CCTV%20surveillance%20camera%20underground%20parking%20lot%20monitoring%20system%20Korea%20apartment%20security%20multiple%20screens%20control%20room&width=400&height=300&seq=park03&orientation=portrait',
  },
  {
    title: '무인 주차 시스템',
    desc: '방문자 주차, 거주자 방문 차량 자동으로 관리하는 무인 주차관리 시스템',
    img: 'https://readdy.ai/api/search-image?query=automated%20parking%20system%20smart%20parking%20management%20visitor%20parking%20Korea%20apartment%20complex%20green%20floor%20marking%20technology%20unmanned%20system&width=400&height=300&seq=park04&orientation=portrait',
  },
];

interface FeatureItem {
  title: string;
  desc: string;
  img: string;
}

interface FeatureSectionProps {
  category: string;
  title: string;
  items: FeatureItem[];
  accent: string;
  dark?: boolean;
}

function FeatureSection({ category, title, items, accent, dark = false }: FeatureSectionProps) {
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    itemRefs.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`py-10 md:py-20 px-4 ${dark ? 'bg-[#0f1e45]' : 'bg-white'}`}>
      <div className="max-w-[1200px] mx-auto">
        {/* Section Header */}
        <div className="mb-8 md:mb-14">
          {/* Badge */}
          <div className="flex items-center justify-center mb-4 md:mb-5">
            <span
              className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1 md:py-1.5 rounded-full text-[10px] md:text-[11px] font-bold tracking-[0.2em] md:tracking-[0.25em] uppercase border"
              style={{
                color: accent,
                borderColor: `${accent}55`,
                backgroundColor: dark ? `${accent}18` : `${accent}12`,
              }}
            >
              <span className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full inline-block" style={{ backgroundColor: accent }}></span>
              {category}
              <span className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full inline-block" style={{ backgroundColor: accent }}></span>
            </span>
          </div>

          {/* Title with decorative lines */}
          <div className="flex items-center justify-center gap-2 md:gap-4 mb-3 md:mb-4">
            <div className="flex items-center gap-1 md:gap-1.5">
              <span className="block w-6 md:w-10 h-[1px]" style={{ backgroundColor: `${accent}60` }}></span>
              <span className="block w-1.5 h-1.5 md:w-2 md:h-2 rotate-45 border" style={{ borderColor: accent }}></span>
            </div>
            <h2
              className={`text-xl md:text-3xl font-bold tracking-tight ${dark ? 'text-white' : 'text-[#1a2b5c]'}`}
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              {title}
            </h2>
            <div className="flex items-center gap-1 md:gap-1.5">
              <span className="block w-1.5 h-1.5 md:w-2 md:h-2 rotate-45 border" style={{ borderColor: accent }}></span>
              <span className="block w-6 md:w-10 h-[1px]" style={{ backgroundColor: `${accent}60` }}></span>
            </div>
          </div>

          {/* Bottom accent line */}
          <div className="flex items-center justify-center gap-1 md:gap-1.5">
            <span className="block w-12 md:w-16 h-[2px] rounded-full" style={{ backgroundColor: `${accent}40` }}></span>
            <span className="block w-4 md:w-6 h-[2px] rounded-full" style={{ backgroundColor: accent }}></span>
            <span className="block w-12 md:w-16 h-[2px] rounded-full" style={{ backgroundColor: `${accent}40` }}></span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              ref={(el) => { itemRefs.current[i] = el; }}
              className={`opacity-0 translate-y-8 transition-all duration-700 rounded-xl overflow-hidden cursor-pointer
                ${dark
                  ? 'bg-[#1a2f5e] border border-[#2a3f7e] hover:border-[#c9a84c] hover:shadow-lg hover:shadow-[#c9a84c]/10'
                  : 'bg-white border border-gray-100 shadow-sm hover:shadow-md'
                } hover:-translate-y-1`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-full h-[130px] md:h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3
                  className={`text-xs md:text-base font-bold mb-1 md:mb-1.5 ${dark ? 'text-white' : 'text-[#1a2b5c]'}`}
                  style={{ fontFamily: "'Noto Serif KR', serif" }}
                >
                  {item.title}
                </h3>
                <p className={`text-[10px] md:text-xs leading-relaxed ${dark ? 'text-blue-200/70' : 'text-gray-500'}`}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function LocationPremiumPage() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-6');
          }
        });
      },
      { threshold: 0.1 }
    );
    itemRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero */}
      <section className="relative h-[180px] md:h-[320px] overflow-hidden mt-16 md:mt-20">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20luxury%20apartment%20complex%20exterior%20glass%20facade%20high-rise%20residential%20building%20Korea%20premium%20architecture%20blue%20sky%20urban%20landmark%20elegant%20tower%20building%20wide%20angle&width=1400&height=320&seq=premiumhero01&orientation=landscape"
          alt="프리미엄 히어로"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#1a2b5c]/55"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
          <p className="text-[10px] md:text-sm tracking-[0.3em] uppercase mb-1.5 md:mb-2 opacity-80">
            Location Premium
          </p>
          <h1 className="text-xl md:text-4xl font-bold tracking-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            프리미엄
          </h1>
          <p className="mt-1.5 md:mt-2 text-[10px] md:text-sm opacity-75">
            최첨단 프리미엄 시스템으로 완성되는 녹색한 가치
          </p>
        </div>
        <div className="absolute bottom-2 md:bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1 md:gap-1.5 text-white/70 text-[10px] md:text-xs">
          <span>홈</span>
          <i className="ri-arrow-right-s-line text-xs md:text-sm"></i>
          <span>입지안내</span>
          <i className="ri-arrow-right-s-line text-xs md:text-sm"></i>
          <span className="text-white font-semibold">프리미엄</span>
        </div>
      </section>

      {/* Title Section */}
      <section className="py-8 md:py-16 text-center px-4 bg-white">
        {/* Top ornament */}
        <div className="flex items-center justify-center gap-2 md:gap-3 mb-4 md:mb-5">
          <span className="block w-8 md:w-12 h-[1px] bg-[#c9a84c]/40"></span>
          <span className="block w-1.5 h-1.5 md:w-2 md:h-2 rotate-45 border border-[#c9a84c]"></span>
          <span className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-5 py-1 md:py-1.5 rounded-full border border-[#c9a84c]/50 bg-[#c9a84c]/8 text-[#c9a84c] text-[10px] md:text-[11px] font-bold tracking-[0.2em] md:tracking-[0.25em] uppercase">
            <span className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full bg-[#c9a84c] inline-block"></span>
            청주 新 주거타운
            <span className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full bg-[#c9a84c] inline-block"></span>
          </span>
          <span className="block w-1.5 h-1.5 md:w-2 md:h-2 rotate-45 border border-[#c9a84c]"></span>
          <span className="block w-8 md:w-12 h-[1px] bg-[#c9a84c]/40"></span>
        </div>

        <h2
          className="text-lg md:text-4xl font-bold text-[#1a2b5c] leading-tight mb-3 md:mb-4"
          style={{ fontFamily: "'Noto Serif KR', serif" }}
        >
          청주를 대표하는 49층 랜드마크를 완성하다!
        </h2>

        {/* Bottom accent line */}
        <div className="flex items-center justify-center gap-1 md:gap-1.5 mb-2 md:mb-3">
          <span className="block w-12 md:w-16 h-[2px] rounded-full bg-[#c9a84c]/30"></span>
          <span className="block w-6 md:w-8 h-[2px] rounded-full bg-[#c9a84c]"></span>
          <span className="block w-12 md:w-16 h-[2px] rounded-full bg-[#c9a84c]/30"></span>
        </div>

        <p className="text-xs md:text-sm text-gray-500">
          최첨단 <span className="text-[#c9a84c] font-medium">프리미엄</span> 시스템으로 새로운 주거 가치를 제공합니다
        </p>

        <div className="mt-6 md:mt-8 w-full max-w-[1200px] mx-auto rounded-xl overflow-hidden">
          <img
            src="https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/54641bec5fb3b970ec02829b777cafab.png"
            alt="프리미엄 이미지"
            className="w-full h-auto object-cover"
          />
        </div>
      </section>

      {/* 특화설계 — 흰 배경 */}
      <FeatureSection
        category="특화설계"
        title="특화설계"
        items={specialFeatures}
        accent="#c9a84c"
        dark={false}
      />

      {/* 스마트 단지 — 남색 배경 */}
      <FeatureSection
        category="스마트 단지"
        title="스마트 단지"
        items={smartFeatures}
        accent="#c9a84c"
        dark={true}
      />

      {/* 시큐리티 — 흰 배경 */}
      <FeatureSection
        category="시큐리티"
        title="시큐리티"
        items={securityFeatures}
        accent="#c9a84c"
        dark={false}
      />

      {/* 주차시스템 — 남색 배경 */}
      <FeatureSection
        category="주차시스템"
        title="주차시스템"
        items={parkingFeatures}
        accent="#c9a84c"
        dark={true}
      />

      {/* CTA - 분양 문의 / 예약 */}
      <section className="py-10 md:py-16 px-4 bg-[#1a2b5c] relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "url('https://readdy.ai/api/search-image?query=elegant%20abstract%20geometric%20pattern%20with%20subtle%20lines%20and%20shapes%2C%20dark%20navy%20blue%20luxury%20background%20texture%2C%20minimalist%20architectural%20detail&width=1400&height=400&seq=cta-bg-pattern-002&orientation=landscape')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <p className="text-yellow-300 text-[10px] md:text-[14px] tracking-widest mb-2 md:mb-3 font-medium">
            CENTRAL CHEONGJU
          </p>
          <h2
            className="text-lg md:text-[36px] font-bold text-white leading-tight mb-3 md:mb-4"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            센트럴 청주의 특권,<br />지금 바로 확인하세요
          </h2>
          <p className="text-white/70 text-[11px] md:text-[15px] leading-relaxed mb-8 md:mb-10">
            압도적 입지와 프리미엄 생활 인프라를 갖춘 센트럴 청주.<br className="hidden md:block" />
            분양 문의 및 견본주택 방문 예약을 지금 신청하세요.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="/reservation"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-[#1a2b5c] font-bold text-xs md:text-[16px] px-6 md:px-8 py-3 md:py-4 rounded-lg transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-calendar-check-line text-base md:text-lg"></i>
              견본주택 방문 예약
            </a>
            <a
              href="tel:1555-5475"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold text-xs md:text-[16px] px-6 md:px-8 py-3 md:py-4 rounded-lg transition-all cursor-pointer"
            >
              <i className="ri-phone-line text-base md:text-lg"></i>
              분양 문의 전화
            </a>
          </div>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 text-white/60 text-[10px] md:text-[13px]">
            <div className="flex items-center gap-1.5 md:gap-2">
              <i className="ri-time-line text-yellow-300 text-xs md:text-sm"></i>
              <span>상담 운영시간 : 평일 09:00 ~ 18:00</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-white/20"></div>
            <div className="flex items-center gap-1.5 md:gap-2">
              <i className="ri-map-pin-line text-yellow-300 text-xs md:text-sm"></i>
              <span>견본주택 : 청주시 서원구 가경동 일원</span>
            </div>
          </div>
        </div>
      </section>

      {/* 모바일 고정 플로팅 CTA 바 */}
      <div className="fixed bottom-0 left-0 right-0 z-[90] md:hidden">
        <div className="h-[2px] bg-gradient-to-r from-[#b8972a] via-[#f0d060] to-[#b8972a] cta-glow"></div>
        <div className="bg-gradient-to-r from-[#0a1229] via-[#1a2b5c] to-[#0a1229] px-3 py-3 flex items-center gap-2.5 shadow-2xl">
          <Link
            to="/reservation"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group cta-pulse"
            style={{ background: 'linear-gradient(135deg, #b8972a 0%, #f0d060 40%, #c9a84c 70%, #b8972a 100%)' }}
          >
            <div className="absolute inset-0 bg-white/0 group-active:bg-white/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent cta-shimmer"></div>
            </div>
            <i className="ri-calendar-check-line text-[#0a1229] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#0a1229] relative z-10">방문예약</span>
          </Link>
          <a
            href="tel:1555-5475"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-white rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group border-2 border-white/30"
          >
            <div className="absolute inset-0 bg-[#1a2b5c]/0 group-active:bg-[#1a2b5c]/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-[#1a2b5c]/15 to-transparent cta-shimmer" style={{ animationDelay: '1.1s' }}></div>
            </div>
            <i className="ri-phone-fill text-[#1a2b5c] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#1a2b5c] relative z-10">전화상담</span>
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
